import {createSelector} from 'reselect';
export const pays = state => state.pays;
export const paysSelector = createSelector(pays, data => data);
